module.exports = __webpack_public_path__ + "img/RabbitMQ.9cc75186.svg";